import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
    getAllProjects: [],
    getAll: [],
    getApprovedStats: [],
    getDisapprovedStats: [],
  },
  getters: {
    getAllProjects: (state) => state.getAllProjects,
    getAll: (state) => state.getAll,
    getApprovedStats: (state) => state.getApprovedStats,
    getDisapprovedStats: (state) => state.getDisapprovedStats,
  },
  actions: {
    getAllProjects({ commit}, param) {
      return new Promise((resolve,reject)=>{
        axios.get(`${BASE_URL}/projects/adminPanel/${param}`).then((response) => {
          if(response.data.status=='success')
            commit("setAllProjects",response.data.data)
          else
            commit("setAllProjects",false)
          resolve(true)
          }).catch((err)=>{
            reject(err)
         });
      })
    },
    getProjectByUri({ commit}, param) {
      return new Promise((resolve,reject)=>{
        axios.get(`${BASE_URL}/projects/uri/${param}`).then((response) => {
          if(response.data.status=='success')
               resolve(response.data)
          }).catch((err)=>{
            reject(err)
         });
      })
    },
    getAll({ commit}) {
      return new Promise((resolve,reject)=>{
        axios.get(`${BASE_URL}/projects`).then((response) => {
          if(response.data)
            commit("setAll",response.data)
          else
            commit("setAll",false)
          resolve(true)
          }).catch((err)=>{
            reject(err)
         });
      })
    },
    getApprovedStats({ commit}) {
      return new Promise((resolve,reject)=>{
        axios.get(`${BASE_URL}/projects/adminApprovedStats`).then((response) => {
          if(response.data)
            commit("setAllApproved",response.data.data)
          else
            commit("setAllApproved",false)
          resolve(true)
          }).catch((err)=>{
            reject(err)
         });
      })
    },
    getDisapprovedStats({ commit}) {
      return new Promise((resolve,reject)=>{
        axios.get(`${BASE_URL}/projects/adminDisApprovedStats`).then((response) => {
          if(response.data)
            commit("setAllDisapproved",response.data.data)
          else
            commit("setAllDisapproved",false)
          resolve(true)
          }).catch((err)=>{
            reject(err)
         });
      })
    },
    approvalProcess({dispatch},payload){
      return new Promise((resolve,reject)=>{
        axios.post(`${BASE_URL}/projects/new-admin/approval`,payload).then(async (response)=>{
          if(response.data.status=='success'){
           await dispatch('getAllProjects',payload.refer)
          }
           resolve(true)
        }).catch((err)=>{
           reject(err)
        })
        })
    },
    
    upgradeProject({}, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let urlResponse = await axios.post(`${BASE_URL}/projects/upgradeProject`, payload);
          if (urlResponse.status="success") {
            resolve("updated successfully!");
          } else {
            throw('upgradeProject api failed!');
          }
        } catch(err) {
          reject(err);
        }
      });
    },

    getCommunityVideos: async ({ commit }) => {
      try {
        const response = await axios.get(`${BASE_URL}/projects/getCommunityVideos`)
        return response.data.data
      } catch (error) {
        throw error
      }
    },

    addCommunityVideo: async ({ commit }, videoData) => {
      try {
        const response = await axios.post(`${BASE_URL}/projects/addCommunityVideo`, videoData)
        return response.data
      } catch (error) {
        throw error
      }
    },

    updateCommunityVideo: async ({ commit }, videoData) => {
      try {
        const response = await axios.put(`${BASE_URL}/projects/updateCommunityVideo/${videoData.id}`, videoData)
        return response.data
      } catch (error) {
        throw error
      }
    },

    deleteCommunityVideo: async ({ commit }, videoId) => {
      try {
        const response = await axios.delete(`${BASE_URL}/projects/deleteCommunityVideo/${videoId}`)
        return response.data
      } catch (error) {
        throw error
      }
    },

    updateCommunityVideoStatus: async ({ commit }, { videoId, status }) => {
      try {
        const response = await axios.post(`${BASE_URL}/projects/updateCommunityVideoStatus`, { videoId, status })
        return response.data
      } catch (error) {
        throw error
      }
    },
    
    getCommunityVideosByType: async ({ commit }, type) => {
      try {
        const response = await axios.get(`${BASE_URL}/projects/getCommunityVideosByType/${type}`)
        return response.data.data
      } catch (error) {
        throw error
      }
    },

    getActiveCommunityVideos: async ({ commit }) => {
      try {
        const response = await axios.get(`${BASE_URL}/projects/getActiveCommunityVideos`)
        return response.data.data
      } catch (error) {
        throw error
      }
    }

  },
  mutations: {
    setAllProjects: (state, projectData) => (state.getAllProjects = projectData),    
    setAll: (state, projectAll) => (state.getAll = projectAll),    
    setAllApproved: (state, projectAllApproved) => (state.getApprovedStats = projectAllApproved),    
    setAllDisapproved: (state, projectAllDisapproved) => (state.getDisapprovedStats = projectAllDisapproved),    
  },
};
